import React from "react";
import styled from "styled-components";
import useWindowSize from "../layout/useWindowSize";

const Modal = ({ state, content, footer, modalAction, maxWidth, custom }) => {
  const windowSize = useWindowSize();
  return (
    <ModalContainer state={state} maxWidth={maxWidth} custom={custom !== undefined ? windowSize.width : null}>
      <div className="modal-content">
        <div className="modal-body">{content}</div>
        <div className="modal-footer">{footer}</div>
      </div>
    </ModalContainer>
  );
};

export default Modal;

const ModalContainer = styled.div.attrs((props) => ({
  display: props.state === "show" ? "block" : "none",
  maxWidth: props.maxWidth !== undefined ? props.maxWidth : "500px",
  padding:
    props.custom !== null
      ? props.custom < 1920 && props.custom >= 1536
        ? "30px 0 0 0 !important"
        : props.custom < 1536
        ? "10px 0 0 0 !important"
        : "50px 0 0 0 !important"
      : "50px 0 0 0 !important",
}))`
  display: ${(props) => props.display}; /* Hidden by default */
  position: fixed !important; /* Stay in place */
  z-index: 1000; /* Sit on top */
  left: 0 !important;
  top: 0 !important;
  width: 100% !important; /* Full width */
  height: 100% !important; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0) !important; /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4) !important; /* Black w/ opacity */
  padding: ${(props) => props.padding};
  box-sizing: border-box !important;

  .modal-content {
    background-color: #fefefe;
    margin: 15% auto; /* 15% from the top and centered */
    padding: 20px !important;
    width: 100%; /* Could be more or less, depending on screen size */
    max-width: ${(props) => props.maxWidth};
    color: #333 !important;
  }

  .modal-content {
    position: relative !important;
    background-color: #fefefe !important;
    margin: auto !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    width: 100% !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    animation-name: modal-animatetop;
    animation-duration: 0.4s;
    border-radius: 10px !important;
  }

  @keyframes modal-animatetop {
    from {
      top: -300px;
      opacity: 0;
    }
    to {
      top: 0;
      opacity: 1;
    }
  }
`;
